import { HostFamilyFilters } from '../../types/models/host-family/host-family'

export const transformHostFamilyFiltersToUrl = (filters?: HostFamilyFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters?.deactivated !== undefined)
    searchParams.append('deactivated', filters.deactivated.toString())

  if (filters?.city) searchParams.append('city', filters.city)

  if (filters?.hasComments !== undefined)
    searchParams.append('hasComments', filters.hasComments.toString())

  if (filters?.dateOfVisit !== undefined)
    searchParams.append('hasComments', filters.dateOfVisit.toString())

  if (filters?.olId) searchParams.append('olId', filters.olId.toString())

  return searchParams.toString()
}

export const transformUrlToHostFamilyFilters = (
  searchParams: URLSearchParams
): HostFamilyFilters => {
  const filters: HostFamilyFilters = {}

  const deactivated = searchParams.get('deactivated')
  if (deactivated) filters.deactivated = deactivated === 'true'

  const city = searchParams.get('city')
  if (city) filters.city = city

  const hasComments = searchParams.get('hasComments')
  if (hasComments) filters.hasComments = hasComments === 'true'

  const dateOfVisit = searchParams.get('dateOfVisit')
  if (dateOfVisit) filters.dateOfVisit = dateOfVisit === 'true'

  const olId = searchParams.get('olId')
  if (olId) filters.olId = +olId

  return filters
}
